import React, { useState } from 'react';
import CopySendLinkModal from './CopySendLinkModal';
import CreateLinkModal from './CreateLinkModal';

export default function PaymentLinkModal({
  isOpen,
  onClose,
  paymentLink,
  originFlow,
  isJussub,
}) {
  const [paymentLinkData, setPaymentLinkData] = useState(paymentLink || null);

  return (
    <>
      {paymentLinkData ? (
        <CopySendLinkModal
          isOpen={isOpen}
          onClose={onClose}
          codeLink={paymentLinkData.hashLink}
          expirationDate={paymentLinkData.expirationDate}
          email={paymentLinkData.email}
          plan={paymentLinkData.plan}
          isJussub={isJussub}
        />
      ) : (
        <CreateLinkModal
          isOpen={isOpen}
          onClose={onClose}
          setPaymentLink={setPaymentLinkData}
          originFlow={originFlow}
        />
      )}
    </>
  );
}
